export const CAMERA_PLAYER_PAGE_ROUTE = 'cameraPlayer';
export const CAMERA_DETAIL_ROUTE = 'video/cameras';
